import {
  CREATING_CUSTOM_FIELD_REQUEST, CREATING_CUSTOM_FIELD_SUCCEEDED, CREATING_CUSTOM_FIELD_FAILED,
  UPDATING_CUSTOM_FIELD_REQUEST, UPDATING_CUSTOM_FIELD_SUCCEEDED, UPDATING_CUSTOM_FIELD_FAILED,
  FETCHING_CUSTOM_FIELD_REQUEST, FETCHING_CUSTOM_FIELD_SUCCEEDED, FETCHING_CUSTOM_FIELD_FAILED,
  FETCHING_CUSTOM_FIELDS_REQUEST, FETCHING_CUSTOM_FIELDS_SUCCEEDED, FETCHING_CUSTOM_FIELDS_FAILED,
  DELETING_CUSTOM_FIELD_REQUEST, DELETING_CUSTOM_FIELD_SUCCEEDED, DELETING_CUSTOM_FIELD_FAILED, UPDATING_GOOGLE_ANALYTICS_REQUEST,
  REORDERING_CUSTOM_FIELD_REQUEST, REORDERING_CUSTOM_FIELD_SUCCEEDED, REORDERING_CUSTOM_FIELD_FAILED
} from './actionTypes.jsx';

import axios from 'axios';
import buildUrl from 'build-url-ts';

const apiUrl = `${process.env.REACT_APP_API_URL}`;
const API_BASE_URL = `${apiUrl}/api/2.0`;
const CUSTOM_FIELD_URL = `${API_BASE_URL}/custom_fields`;


/**
 * Creating Contact List
 */
export function createCustomField(request) {
  return function (dispatch) {
    dispatch(creatingCustomField());

    return axios({
      method: "POST",
      url: CUSTOM_FIELD_URL,
      data: request
    })
    .then(response => {
      return dispatch(creatingCustomFieldSucceeded(response.data));
    })
    .catch(error =>{
      return dispatch(creatingCustomFieldFailed(error));
    })
  }
}

function creatingCustomField() {
  return {
    type: CREATING_CUSTOM_FIELD_REQUEST,
    payload: {}
  }
}

function creatingCustomFieldSucceeded(json) {
  return {
    type: CREATING_CUSTOM_FIELD_SUCCEEDED,
    payload: json
  }
}

function creatingCustomFieldFailed(error) {
  return {
    type: CREATING_CUSTOM_FIELD_SUCCEEDED,
    payload: error
  }
}

/**
 * Updating Custom List
 */
export function updateCustomField(id, request) {
  return function(dispatch) {
    dispatch(updatingCustomField(id));

    let url = buildUrl(CUSTOM_FIELD_URL, {
      path: `${id}`
    });

    return axios({
      method: "PUT",
      url: url,
      data: request
    })
    .then(response => {
      return dispatch(updatingCustomFieldSucceeded(id, response.data));
    })
    .catch(error => {
      return dispatch(updatingCustomFieldFailed(id, error));
    })
  }
}

function updatingCustomField(id) {
  return {
    type: UPDATING_CUSTOM_FIELD_REQUEST,
    payload: id
  }
}

function updatingCustomFieldSucceeded(id, json) {
return {
  type: UPDATING_CUSTOM_FIELD_SUCCEEDED,
  payload: {
      id: id,
      response: json
    }
  }
}

function updatingCustomFieldFailed(id, error) {
  return {
    type: UPDATING_CUSTOM_FIELD_FAILED,
    payload: {
      id: id,
      error: error
    }
  }
}

/**
 * Fetching CustomField
 */
export function fetchCustomField(id) {
  return function (dispatch) {
    dispatch(fetchingCustomField(id));

    let url = buildUrl(CUSTOM_FIELD_URL, {
      path: `${id}`
    });

    return axios({
      method: "GET",
      url: url
    })
    .then(response => {
      return dispatch(fetchingCustomFieldSucceeded(id, response.data))
    })
    .catch(error => {
      return dispatch(fetchingCustomFieldFailed(id, error))
    })
  }
}

function fetchingCustomField(id) {
  return {
    type: FETCHING_CUSTOM_FIELD_REQUEST,
    payload: id
  }
}

function fetchingCustomFieldSucceeded(id, json) {
  return {
    type: FETCHING_CUSTOM_FIELD_SUCCEEDED,
    payload: {
      id: id,
      response: json
    }
  }
}

function fetchingCustomFieldFailed(id, error) {
  return {
    type: FETCHING_CUSTOM_FIELD_FAILED,
    payload: {
      id: id,
      error: error
    }
  }
}

/**
 * Fetching Custom fields
 */
export function fetchCustomFields() {
  return function(dispatch) {
    dispatch(fetchingCustomFields());

    return axios({
      method: "GET",
      url: CUSTOM_FIELD_URL
    })
    .then(response => {
      return dispatch(fetchingCustomFieldsSucceeded(response.data));
    })
    .catch(error => {
      return dispatch(fetchingCustomFieldsFailed(error))
    })
  }
}

function fetchingCustomFields() {
  return {
    type: FETCHING_CUSTOM_FIELDS_REQUEST,
    payload: {}
  }
}

function fetchingCustomFieldsSucceeded(json) {
  return {
    type: FETCHING_CUSTOM_FIELDS_SUCCEEDED,
    payload: json
  }
}

function fetchingCustomFieldsFailed(error) {
  return {
    type: FETCHING_CUSTOM_FIELDS_FAILED,
    payload: error
  }
}

/**
 * Delete Custom field
 */
export function deleteCustomField(id) {
  return function(dispatch) {
    dispatch(deletingCustomField(id));

    let url = buildUrl(CUSTOM_FIELD_URL, {
      path: `${id}`
    });

    return axios({
      method: "DELETE",
      url: url
    })
    .then(response => {
      return dispatch(deletingCustomFieldSucceeded(id, response.data));
    })
    .catch(error => {
      return dispatch(deletingCustomFieldFailed(id, error));
    })
  }
}

function deletingCustomField(id) {
  return {
    type: DELETING_CUSTOM_FIELD_REQUEST,
    payload: id
  }
}

function deletingCustomFieldSucceeded(id, json) {
  return {
    type: DELETING_CUSTOM_FIELD_SUCCEEDED,
    payload: {
      id: id,
      resposne: json
    }
  }
}

function deletingCustomFieldFailed(id, error) {
  return {
    type: DELETING_CUSTOM_FIELD_FAILED,
    payload: {
      id: id, 
      error: error
    }
  }
}

export function reorderCustomField(request) {
  return function (dispatch) {
    dispatch(reorderingCustomField());

    let url = buildUrl(CUSTOM_FIELD_URL, {
      path: "/order"
    });

    return axios({
      method: "PUT",
      url: url,
      data: request
    })
    .then(response => {
      return dispatch(reorderCustomFieldSucceeded(response.data));
    })
    .catch(error =>{
      return dispatch(reorderCustomFieldFailed(error));
    })
  }
}

function reorderingCustomField() {
  return {
    type: REORDERING_CUSTOM_FIELD_REQUEST,
    payload: {}
  }
}

function reorderCustomFieldSucceeded(json) {
  return {
    type: REORDERING_CUSTOM_FIELD_SUCCEEDED,
    payload: json
  }
}

function reorderCustomFieldFailed(error) {
  return {
    type: REORDERING_CUSTOM_FIELD_FAILED,
    payload: error
  }
}